"use strict";const e=require("styled-components").css`
    &.PlannerQuestion {
        text-align: center;
        background: ${({theme:e})=>e.colors.common.light};

        .PlannerQuestion-content {
            margin: ${({theme:e})=>e.spacing.xlarge} auto;
        }
    }
`;module.exports=e;
//# sourceMappingURL=styles.js.map
